import React from "react";
import { StepBubbles, FormInvoice } from "~/components/blocks";
import { Margin, Title, Text, Alert } from "~/components/elements";

import { Grid } from "@material-ui/core";
import isMobile from "~/hooks/isMobile";

import * as S from "./styles";

export default function InvoiceContent({
  step,
  openModalProduct,
  products,
  openModalQuestion,
  removeProduct
}) {
  const mobile = isMobile();

  return (
    <S.PageContainer>
      <Grid container justifyContent="center">
        <Margin mt={mobile ? 4 : 9} mb={8}>
          <S.TitleHolder>
            <Title as="1" levelDesktop="4" level="4">
              <strong>Registre sua compra</strong>
            </Title>
            <Margin pt={3} mb={2} pl={mobile? 1 : 4} pr={mobile ? 1 : 4}>
              <Margin pb={2}>
                <Text level="2" primary>
                  <Text level="2" as="strong">
                    Chegou a hora de registrar sua compra:
                  </Text>{" "}
                  preste atenção nas informações requisitadas e preencha todos os campos de acordo com os dados da sua nota fiscal e dos produtos adquiridos.
                </Text>
              </Margin>
              <Text level="2" primary>
                Lembre-se de que todos os produtos devem estar em uma única nota fiscal,{" "}
                <span style={{ color: "#DB3939", fontWeight: "bold" }}>
                  contendo o CPF informado no cadastro ou sem CPF.
                </span>{" "}
                Compras com CPF diferente do cadastro não serão aceitas.
              </Text>
            </Margin>
            <Margin>
              <Alert type="warning" size="sm">
                <strong>Atenção: guarde a nota fiscal cadastrada até o final da promoção.</strong>
              </Alert>
            </Margin>
            <Margin pb={mobile ? 0 : 2}>
              <StepBubbles step={step} mobile={mobile} />
            </Margin>
          </S.TitleHolder>
          <FormInvoice
            mobile={mobile}
            openModalProduct={openModalProduct}
            openModalQuestion={openModalQuestion}
            removeProduct={removeProduct}
            products={products}
          />
        </Margin>
      </Grid>
    </S.PageContainer>
  );
}
